// Mirrors practice/detailTabs.ts's shape, trimmed to the three tabs this org
// view actually has - no billing/communications/overview gating needed here.

export interface DetailTabDef {
    id: string;
    label: string;
}

export const DETAIL_TABS: readonly DetailTabDef[] = [
    { id: 'details', label: 'Details' },
    { id: 'users', label: 'Users' },
    { id: 'patients', label: 'Patients' }
];

export type DetailTabId = (typeof DETAIL_TABS)[number]['id'];

export const DEFAULT_TAB: DetailTabId = 'details';

export function isDetailTab(value: string): value is DetailTabId {
    return DETAIL_TABS.some((tab) => tab.id === value);
}
